export { SYSTEM_DATA_THEMES } from '../../../utils/constant';
export const testIds = { CAROUSEL_CLOSE_BUTTON: 'carousel-close-button' };
export const timers = {
  CAROUSEL_TRANSITION_DELAY: 500,
  CAROUSEL_MENU_CLOSE_TRANSITION_DELAY_MS: 10,
  CAROUSEL_CLOSE_DELAY: 220,
};

export const CAROUSEL_CARDS = {
  PREV2: 'previous_2',
  PREV1: 'previous_1',
  MID: 'middle',
  NEXT1: 'forward_1',
  NEXT2: 'forward_2',
};
